import { createStyles } from '@mantine/core';

const useProgramAgendaStyles = createStyles(theme => ({
  agendaContent: {
    padding: `${theme.spacing.xl} calc(${theme.spacing.xl} * 2) calc(${theme.spacing.xl} * 2)`,
    gap: theme.spacing.md,
  },
  header: {
    paddingBottom: theme.spacing.xs,
  },
  grid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: `0 ${theme.spacing.md}`,
  },
  agendaItem: {
    isolation: 'isolate',
  },
  firstColumn: {
    paddingLeft: theme.spacing.sm,
    borderRadius: theme.radius.md,
    overflow: 'hidden',
    alignItems: 'center',
  },
  lastColumn: {
    borderRadius: theme.radius.md,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    backgroundColor: theme.colors.gray[0],
  },
  shadow: {
    boxShadow: theme.shadows.sm,
  },
  calendar: {
    fontFamily: `${theme.fontFamily} !important`,
    borderRadius: theme.radius.md,
  },
}));

export default useProgramAgendaStyles;
